<template>
    <div class="chat-container">
        <router-view :timer="timer" :score="score"></router-view>
    </div>
</template>
<script>
import Bus from '../main.js'
export default {
    props: {
        timer : {},
    },
    data(){
        return{
            score : ''
        }
    },
    async created(){
        // const { score } = await this.$store.getters.getSimple(['score'])
        // this.$store.dispatch('simpleSave', {
        //     score
        // })
    }
}
</script>
<style lang="scss" scoped>
    .chat-container{
        height: calc(100% - 65px);
    }
</style>
